import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import routes from './routes';

import PrivateLayout from 'wrappers/PrivateLayout';
import PublicLayout from 'wrappers/PublicLayout';

const RouterPath = () => {
  return (
    <Routes>
      {routes.map((route, index) => {
        const { key, path, component: Component, isAuthRequired } = route;
        return (
          <Route
            key={`${key}-${index}`}
            path={path}
            element={
              isAuthRequired ? (
                <Suspense fallback={<>...</>}>
                  <PrivateLayout>
                    <Component />
                  </PrivateLayout>
                </Suspense>
              ) : (
                <Suspense fallback={<>...</>}>
                  <PublicLayout>
                    <Component />
                  </PublicLayout>
                </Suspense>
              )
            }
          >
            {route?.subRoutes &&
              route.subRoutes?.map((subRoute, index) => {
                const {
                  key,
                  path,
                  component: Component,
                  isAuthRequired,
                  index: isIndex,
                } = subRoute;
                return (
                  <Route
                    index={isIndex}
                    key={`${key}-${index}`}
                    path={path}
                    element={
                      isAuthRequired ? (
                        <Suspense fallback={<>...</>}>
                          <Component />
                        </Suspense>
                      ) : (
                        <Suspense fallback={<>...</>}>
                          <Component />
                        </Suspense>
                      )
                    }
                  />
                );
              })}
          </Route>
        );
      })}
      {/* TODO: Add 404 page */}
      {/* <Route path="/404" element={<NotFound />} /> */}
      <Route path="*" element={<Navigate to="/not-found" />} />
    </Routes>
  );
};

export default RouterPath;
